import React from 'react';

import Icon from './Icon';

const ArrowDownIcon = (props) => {
    return (
        <Icon width='14' height='8' {...props}>
            <path
                d='M1.667 1.333 7 6.667l5.333-5.334'
                stroke='currentColor'
                strokeWidth='1.5'
                fill='none'
                fillRule='evenodd'
                strokeLinecap='round'
            />
        </Icon>
    );
};

export default ArrowDownIcon;
